import { SearchIcon } from '@music-vine/cadence/icons';

/**
 * Static placeholder for GlobalSearch, rendered on the server and while the
 * dynamic import loads. It replicates the real form's idle state — same
 * wrapper chain, 48px pill, placeholder text and magnifier — so the swap to
 * the interactive component is imperceptible. Its in-flow geometry must stay
 * identical to GlobalSearchForm's (28px row + py-2 + 2px borders, same
 * max-width chain, nothing below md) or the header height jumps at the swap.
 */
export const GlobalSearchSkeleton = () => <div className="relative w-full bg-transparent pt-0" data-sentry-component="GlobalSearchSkeleton" data-sentry-source-file="GlobalSearchSkeleton.tsx">
    <div className="pointer-events-auto relative w-full sm:max-w-[380px] lg:max-w-[450px] xl:max-w-[530px] 2xl:max-w-[572px]">
      <div className="hidden md:block">
        <div className="relative z-50 flex w-full flex-col gap-4 rounded-3xl border-[2px] border-transparent border-solid bg-gray-100 px-5 py-2 pr-2 dark:bg-gray-800">
          <div className="flex flex-1 items-center justify-between">
            {/* pl-0.5 mirrors the input's 2px UA default padding (preflight
                is disabled), keeping the placeholder text from nudging right
                at the swap. */}
            <span className="pl-0.5 font-sans text-gray-700 md:text-xs lg:text-sm dark:text-gray-200">
              Search
            </span>
            <div className="flex items-center justify-center p-1.5">
              <SearchIcon className="h-4 w-4 stroke-[2.5] text-gray-700 dark:text-gray-200" data-sentry-element="SearchIcon" data-sentry-source-file="GlobalSearchSkeleton.tsx" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>;